import Vue from 'vue'
import axios from "axios"
Vue.prototype.axios = axios;
import { Notice } from 'view-design'
import store from '../store/index';
import route from '../router/index';
//发送错误日志
const addErrorLog = errorInfo => {
    const { statusText, status, request: { responseURL } } = errorInfo;
    let info = {
        type: 'axios',
        code: status,
        mes: statusText,
        url: responseURL
    };
    console.log(info)
    //if (!responseURL.includes('save_error_logger')) store.dispatch('addErrorLog', info)
};

axios.defaults.timeout = 30000;//18000
let retry = axios.defaults.retry = 1;//请求次数
let retryDelay = axios.defaults.retryDelay = 1000;//请求间隙

axios.interceptors.request.use(
config => {
    let token = localStorage.getItem('token');
    config.headers.Authorization = token?token:"";
    config.headers.S_Type = "wangting_sq";
    config.headers.S_OpenID = "";
    config.headers.ContentType='application/x-www-form-urlencoded';
    return config;
},err => {
    return Promise.reject(err);
});
axios.interceptors.response.use(res => {
    //console.log(res);
    const {data, status} = res;
    // if (data.Success) {
    //   let msg = { title: '成功', desc: data.Message};
    //   Notice.success(msg)
    // }
    return {data, status}
}, error => {
    if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1) {
        Notice.error({title: '请求超时'})
    }else if (error.response&&error.response.status === 200 && error.response.msg){
        Notice.success({title: error.response.msg})
    } else if (error.response&&error.response.status === 500){
        Notice.error({title: "服务器错误"})
    } else if (error.response&&error.response.status === 400){
        Notice.warning({title: error.response.msg})
    }else if (error.response&&error.response.status === 401) {
        //console.log(error.response)
        //权限错误，登出
        store.commit("CanShowModal",true);
        store.commit("ChangeUserName","");
        store.commit("ChangeBaseLayoutActive","PersonalBusinessList");
        route.push("PersonalBusinessList");
        localStorage.removeItem('token');
        localStorage.removeItem('S_UserFlag');
        localStorage.removeItem('S_UserPhone');
        localStorage.removeItem("CurrentActive");
        localStorage.removeItem("BaseData");
        localStorage.removeItem("ZWWToken");
        return false;
    }
    if(error){
        return false;
    }
    let originalRequest = error.config;
    //如果配置不存在或未设置重试选项，则返回错误信息
    if(!originalRequest|| !retry) return Promise.reject(error.response.data);
    //设置变量即跟踪重试次数
    originalRequest.__retryCount = originalRequest.__retryCount || 1;
    //检查我们是否已经超过了总重试次数
    if(originalRequest.__retryCount >= retry) {
        let errorInfo = error.response;
        if (!errorInfo) return false;
        const { request: { statusText, status }, config } = JSON.parse(JSON.stringify(error));
        errorInfo = {
            statusText,
            status,
            request: { responseURL: config.url }
        };
        Notice.error({title: 'error', desc: errorInfo});
        addErrorLog(errorInfo);
        return Promise.reject(error.response.data);//返回错误信息
    }
    originalRequest.__retryCount += 1;//重试次数加1
    // 创建延时器等待发送重试请求
    let backoff = new Promise(function(resolve){
        setTimeout(function(){
            resolve();
        }, retryDelay || 1);
    });
    // 返回调用axios来重试请求
    return backoff.then(function(){
        return axios(originalRequest);
    });
});

//2->对get请求传递过来的参数处理
function paramsToUrl(url, params) {
    if (!params) return url;
    for (var key in params) {
        if (params[key] && params[key] != 'undefined') {
            if (url.indexOf('?') != -1) {
                url += '&' + '' + key + '=' + params[key] || '' + ''
            } else {
                url += '?' + '' + key + '=' + params[key] || '' + ''
            }
        }
    }
    return url;
}

//3->封装公用方法-----封装请求的方法
function requireData(url,params,type,item){
    if(!url) return false;
    switch(item){
        case "M1":
            url=axios.defaults.InApi + url;
            break;
        case "M2":
            url=axios.defaults.OutApi + url;
            break;
        case "M3":
            url=axios.defaults.TestApi + url;
            break;
        default:
            url=axios.defaults.baseM4URL + url;
            break;
    }
    if(type==='get'){
        url=paramsToUrl(url, params);
        return new Promise((resolve,reject)=>{
            axios.get(url,params).then(res=>{
                resolve(res.data)
            }).catch(err=>{
                reject(err)
            })
        })
    }else{
        return new Promise((resolve,reject)=>{
            axios.post(url,params).then(res=>{
                resolve(res.data)
            }).catch(err=>{
                reject(err)
            })
        })
    }
}

export default{
    install(Vue){
        //->接口1的请求数据方法
        Vue.prototype.InApi=function(url,params,type){
            return requireData.call(this,url,params,type,'M1')
        };
        //->接口2的请求数据方法
        Vue.prototype.OutApi=function(url,params,type){
            return requireData.call(this,url,params,type,'M2')
        };
        //->接口3的请求数据方法
        Vue.prototype.TestApi=function(url,params,type){
            return requireData.call(this,url,params,type,'M3')
        };
        //->接口4的请求数据方法
        Vue.prototype.reqM4Service=function(url,params,type){
            return requireData.call(this,url,params,type,'M4')
        }
    }
}

